<template>
    <ProspectHeader :showLabel="true" cssClass="content-type-35" />
    <component
        v-for="widget in widgets"
        :key="widget.id"
        :is="widget.component"
        v-bind="widget.props"
        :ref="el => registerComponentRef(widget.id, el)"
    />
</template>

<script>
    import ProspectHeader from '@/components/elements/prospect/ProspectHeader';
    import ProspectAiWidget from '@/components/elements/prospect/ProspectAiWidget';
    import ProspectFirmologyAlt from '@/components/elements/prospect/ProspectFirmologyAlt';
    import ProspectContactInfo from '@/components/elements/prospect/ProspectContactInfo';
    import ProspectOpeningHoursAlt from '@/components/elements/prospect/ProspectOpeningHoursAlt';
    import ProspectIndustries from '@/components/elements/prospect/ProspectIndustries';
    import ProspectReviewsSummaryAlt from '@/components/elements/prospect/ProspectReviewsSummaryAlt';
    import ProspectSiteSearch from '@/components/elements/prospect/ProspectSiteSearch';
    import ProspectPeople from '@/components/elements/prospect/ProspectPeople';
    import ProspectFamily from '@/components/elements/prospect/ProspectFamily';
    import ProspectProperty from '@/components/elements/prospect/ProspectProperty';
    import ProspectSameAddress from '@/components/elements/prospect/ProspectSameAddress';
    import ProspectReviewsDetails from '@/components/elements/prospect/ProspectReviewsDetails';
    import ProspectNews from '@/components/elements/prospect/ProspectNews';
    import ProspectVacancies from '@/components/elements/prospect/ProspectVacancies';
    import ProspectAppsDetails from '@/components/elements/prospect/ProspectAppsDetails';
    import ProspectSiteRank from '@/components/elements/prospect/ProspectSiteRank';
    import ProspectContacts from '@/components/elements/prospect/ProspectContacts';
    import ProspectPageViews from '@/components/elements/prospect/ProspectPageViews';
    import ProspectTags from '@/components/elements/prospect/ProspectTags';
    import ProspectAssignment from '@/components/elements/prospect/ProspectAssignment';
    import ProspectEvents from '@/components/elements/prospect/ProspectEvents';
    import { useCompanyWidgetsStore } from '@/stores/companyWidgets';

    export default {
        name: "CompanyDetails",
        components: {
            ProspectHeader,
            ProspectAiWidget,
            ProspectFirmologyAlt,
            ProspectContactInfo,
            ProspectOpeningHoursAlt,
            ProspectIndustries,
            ProspectReviewsSummaryAlt,
            ProspectSiteSearch,
            ProspectPeople,
            ProspectFamily,
            ProspectProperty,
            ProspectSameAddress,
            ProspectReviewsDetails,
            ProspectNews,
            ProspectVacancies,
            ProspectAppsDetails,
            ProspectSiteRank,
            ProspectContacts,
            ProspectPageViews,
            ProspectTags,
            ProspectAssignment,
            ProspectEvents
        },
        computed: {
            widgets() {
                return useCompanyWidgetsStore().getWidgets();
            }
        },
        methods: {
            registerComponentRef(id, el) {
                if (el) {
                    useCompanyWidgetsStore().registerComponentRef(id, el);
                }
            }
        },
        unmounted() {
            useCompanyWidgetsStore().resetWidgetStore();
        }
    }
</script>